import React from "react";
import { RingLoader } from "react-spinners";

const SuspenseLoading = () => {
  return (
    <>
      <div className="d-flex align-items-center flex-column vh-100 justify-content-center text-center bg-primary py-3">
        <div className="d-flex align-items-center flex-column px-4">
          <RingLoader size={90} color={"#000000"} loading={true} />
        </div>
        <div style={{ color: "#000000", fontWeight: "bold", fontSize: "30px" }}>
          Please wait loading...
        </div>
      </div>
    </>
  );
};

export default SuspenseLoading;
